// src/api/agencyApi.js
import axiosInstance from "./axiosConfig";

export const getAgencies = () => {
  return axiosInstance.get("/agencies");
};

export const createAgency = (agencyData) => {
  return axiosInstance.post("/agencies", agencyData);
};
